export default __webpack_public_path__ + "static/media/emoji_heart.d1e59d9f.svg";